<template>
  <div class="practice-selector-menu" :class="{ compact }">
    <template v-if="!compact">
      <div class="practice-header">
        <div class="practice-title">Select Practice</div>
      </div>
      <div class="menu-divider"></div>
    </template>
    <div class="practice-list">
      <button v-for="practice in availablePractices" :key="practice.practiceId" class="button menu-button"
        :class="{ active: practice.name === currentPracticeName }" @click.prevent="handleSelectPractice(practice)">
        {{ practice.name }}
      </button>
    </div>
    <template v-if="!hideCreateNew">
      <div class="menu-divider"></div>
      <div class="create-new-section">
        <button class="button menu-button create-new-button" @click.prevent.stop="handleCreateNew">
          <PlusIcon :size="18" />
          <span>Create New</span>
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import PlusIcon from 'vue-material-design-icons/Plus.vue';

export default {
  name: 'PracticeSelectorMenu',
  components: {
    PlusIcon
  },
  props: {
    currentPracticeName: {
      type: String,
      required: true
    },
    availablePractices: {
      type: Array,
      default: () => []
    },
    hideCreateNew: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSelectPractice(practice) {
      this.$emit('select-practice', practice.practiceId);
    },
    handleCreateNew() {
      this.$emit('create-new');
    }
  },
  emits: ['select-practice', 'create-new']
}
</script>

<style scoped>
.practice-selector-menu {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: var(--border-radius);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 280px;
  overflow: hidden;
}

.practice-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
}

.practice-title {
  font-size: 14px;
  font-weight: 600;
  color: #262626;
}

.menu-divider {
  height: 1px;
  background-color: #f0f0f0;
  margin: 0;
}

.practice-list {
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-y: auto;
}

.menu-button {
  width: 100%;
  text-align: left;
  border-radius: var(--border-radius);
  border: none;
  box-shadow: none;
  position: relative;
}

.menu-button:hover {
  box-shadow: none;
}

.menu-button:active {
  box-shadow: none;
}

.menu-button.active {
  background-color: #e6f4ff;
  color: var(--primary-color);
  font-weight: 500;
  padding-right: 40px;
  border-color: transparent;
}

.menu-button.active:hover {
  background-color: #e6f4ff;
  border-color: transparent;
}

.menu-button.active::after {
  content: '✓';
  position: absolute;
  right: 16px;
  color: var(--primary-color);
}

.create-new-section {
  display: flex;
  flex-direction: column;
}

.create-new-button {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6b7280;
  font-weight: 400;
  font-size: 13px;
  background-color: transparent !important;
}

.create-new-button:hover {
  color: #4b5563;
  background-color: #f9fafb !important;
}

/* Compact variant */
.compact {
  min-width: 200px;
}

.compact .practice-header {
  padding: 8px 10px;
}

.compact .practice-title {
  font-size: 12px;
}

.compact .menu-button {
  font-size: 13px;
  padding: 5px 10px;
}

.compact .menu-button.active {
  padding-right: 32px;
}

.compact .menu-button.active::after {
  right: 10px;
  font-size: 12px;
}
</style>
